import { formValueSelector } from 'redux-form';

import { INFERENTIAL_STATISTICS } from '../../names';

const selector = formValueSelector(INFERENTIAL_STATISTICS);

const makeFieldValueGetter = field =>
  state => selector(state, field);


export const getFirstVariable =
  makeFieldValueGetter('twoSampleProportion.firstVariable');

export const getSecondVariable =
  makeFieldValueGetter('twoSampleProportion.secondVariable');

export const getFirstVariableSuccessGroup =
  makeFieldValueGetter('twoSampleProportion.firstVariableSuccessGroup');

export const getSecondVariableSuccessGroup =
  makeFieldValueGetter('twoSampleProportion.secondVariableSuccessGroup');
